<template>
    <div :class="loaderClasses" />
</template>

<script>
// Mixins
import styles from '../mixins/styles';

// Types
import {
    loaderSizes,
    defaultLoaderSize,
    loaderIndicatiorColor,
    defaultLoaderIndicatiorColor
} from '../types/Loader.types';

// Utils
import { eligibleProp } from '../utils/props-utils';

export default {
    name: 'Loader',
    mixins: [styles],
    props: {
        size: {
            type: String,
            default: defaultLoaderSize,
            validator: eligibleProp(loaderSizes)
        },
        color: {
            type: String,
            default: defaultLoaderIndicatiorColor,
            validator: eligibleProp(loaderIndicatiorColor)
        }
    },
    computed: {
        loaderClasses: function () {
            return [
                this.cssClasses.pcc__loader,
                this.cssClasses[`pcc__loader_${this.size}`],
                this.cssClasses[`pcc__loader_${this.color}Color`],
            ];
        }
    }
}
</script>